import { generateDefaultMandatoryError } from 'Core/utils/messages'

export const CREATE_CONTACT_ERROR = generateDefaultMandatoryError('Contact')
export const CREATE_SITE_EQUIPMENT_ERROR = generateDefaultMandatoryError('Site Equipment')
export const CREATE_ROLE_ERROR = generateDefaultMandatoryError('Role')
export const CREATE_TRANSPORTER_ERROR = generateDefaultMandatoryError('Transporter')
export const CREATE_ITEM_GUIDE_ERROR = generateDefaultMandatoryError('Guide')
export const CREATE_VARIABLE_PRICE_ERROR = generateDefaultMandatoryError('Variable Price')
export const CREATE_WASTE_STREAM_ERROR = generateDefaultMandatoryError('Wastestream')
export const DISPOSAL_FACILITY_ERROR_MESSAGE = generateDefaultMandatoryError('Disposal Facility')
export const WASTE_STREAM_ERROR_MESSAGE = generateDefaultMandatoryError('Wastestream')
export const CREATE_ITEM_TEMPLATE_ERROR = generateDefaultMandatoryError('Item template')
export const ITEM_ERROR_MESSAGE = generateDefaultMandatoryError('Item')
export const CREATE_EDIT_SUPPLIER_ERROR_LABEL = generateDefaultMandatoryError('Supplier')
export const ADD_CERTIFICATE_ERROR = generateDefaultMandatoryError('Certificate')
export const SUPPLIER_LOCATION_VISITS_ERROR_LABEL = generateDefaultMandatoryError('Location Visit')
export const REPORT_VISITS_ERROR_LABEL = generateDefaultMandatoryError('Report')
export const TAX_CATEGORIES_ERROR_LABEL = generateDefaultMandatoryError('Tax Category')
export const TAX_EXEMPTION_ERROR_LABEL = generateDefaultMandatoryError('Tax Exemption')
export const CREATE_EDIT_CONTRACT_ERROR = generateDefaultMandatoryError('Contract')
export const SUPPLIER_LOCATION_SAVE_ERROR = generateDefaultMandatoryError('Supplier Location')
export const CREATE_EDIT_HES_SUPPLIER_ERROR = generateDefaultMandatoryError('HES Supplier')
export const TREATMENT_METHOD_ERROR_MESSAGE = generateDefaultMandatoryError('Treatment Method')
export const CREATE_SUPPLIER_INVOICE_ERROR = generateDefaultMandatoryError('Supplier Invoice')
export const KPI_TRACKING_ERROR_MESSAGE = generateDefaultMandatoryError('KPI Tracking')
export const GENERAL_LIABILITY_ERROR_MESSAGE = generateDefaultMandatoryError('General Liability')
export const AUTO_LIABILITY_ERROR_MESSAGE = generateDefaultMandatoryError('Auto Liability')
export const PRODUCER_ERROR_MESSAGE = generateDefaultMandatoryError('Producer')
export const EXCESS_UMBRELLA_LIABILITY_ERROR_MESSAGE =
	generateDefaultMandatoryError('Excess / Umbrella')
export const SERVICE_SCHEDULE_ERROR_MESSAGE = generateDefaultMandatoryError('Service Schedule')
export const CREATE_SCALE_ERROR_MESSAGE = generateDefaultMandatoryError('Scale')
export const SCALE_PRICE_ERROR_MESSAGE = generateDefaultMandatoryError('Scale Price')
export const WORKERS_LIABILITY_ERROR_MESSAGE = generateDefaultMandatoryError(
	"Worker's Comp / EL Liability"
)
export const SAVE_CURRENT_SERVICE_PRODUCT_STATE_ERROR = generateDefaultMandatoryError(
	'Current Service/Product State'
)
export const DEPENDENT_ITEM_ERROR_MESSAGE = generateDefaultMandatoryError('Dependent Item')
export const OTHER_LIABILITY_ERROR_MESSAGE = generateDefaultMandatoryError('Other Liability')
export const CONFIRM_INVOICE_ERROR_MESSAGE = generateDefaultMandatoryError('Invoice')
export const PRICE_ERROR_MESSAGE = generateDefaultMandatoryError('Price')
export const PARAMETERS_ERROR_MESSAGE = generateDefaultMandatoryError('Parameter')
export const MANIFEST_ERROR_MESSAGE = generateDefaultMandatoryError('Manifest')
export const REPORT_ERROR_MESSAGE = generateDefaultMandatoryError('Report')
export const REPORT_STATUS_ERROR_MESSAGE =
	'Status cannot be changed.  Please fill in mandatory fields:'
export const SERVICE_ERROR_MESSAGE = generateDefaultMandatoryError('Service')
export const SQL_PARAMETERS_ERROR_MESSAGE = generateDefaultMandatoryError('SQL Parameter')
export const ADD_COMMENT_ERROR = generateDefaultMandatoryError('Comment')
export const ADD_EXCEPTION_ERROR = generateDefaultMandatoryError('Exception')
export const WHERE_PARAMETERS_ERROR_MESSAGE = generateDefaultMandatoryError('Where Parameters')
export const CREATE_EDIT_SERVICE_TEAM_ERROR_LABEL = generateDefaultMandatoryError('Service Team')
export const MOU_ERROR_MESSAGE = generateDefaultMandatoryError('MOU')
export const PRODUCT_CATEGORY_ERROR_MESSAGE = generateDefaultMandatoryError('Product Category')
export const TRANSACTION_DOCUMENT_ERROR = generateDefaultMandatoryError('Transaction Document')
export const SERVICE_OCCURRENCE_ERROR = generateDefaultMandatoryError('Service Occurrence')
export const FINAL_DISPOSAL_MANIFEST_ERROR =
	'Final Disposal Facility cannot be empty when a manifest Id has been selected.'
export const EXTRA_CHARGE_OCCURRENCE_ERROR = generateDefaultMandatoryError('Extra Charge')
export const BILLING_ITEM_ERROR_MESSAGE = generateDefaultMandatoryError('Billing Item')
export const PRODUCT_TYPE_ERROR_MESSAGE = generateDefaultMandatoryError('Product Type')
export const PRODUCTS_ERROR_MESSAGE = generateDefaultMandatoryError('Product')
export const PRODUCT_STATE_ERROR_MESSAGE = generateDefaultMandatoryError('Product State')
export const TREATMENT_ERROR_MESSAGE = generateDefaultMandatoryError('Treatment Method')
export const INVOICE_LIST_ERROR_MESSAGE = generateDefaultMandatoryError('Supplier Invoice List')
export const PC_INVENTORY_LOCATION_ERROR_MESSAGE =
	generateDefaultMandatoryError('Inventory Location')
export const CONTAINER_TYPE_ERROR_MESSAGE = generateDefaultMandatoryError('Container Type')
export const ADJUSTMENT_ERROR_MESSAGE = generateDefaultMandatoryError('Adjustment')
export const CREATE_CONTAINER_ERROR = generateDefaultMandatoryError('Container')
export const PC_SUPPLIER_LOCATION_ERROR_MESSAGE = generateDefaultMandatoryError('Supplier Location')
export const CONTAINER_ERROR_MESSAGE = generateDefaultMandatoryError('Container')
export const PC_PRODUCT_WEIGHT_ERROR_MESSAGE = generateDefaultMandatoryError('Product Weight')
export const EPA_FORM_CODE_ERROR_MESSAGE = generateDefaultMandatoryError('EPA Form Code')
export const EPA_HAZ_CODE_ERROR_MESSAGE = generateDefaultMandatoryError('EPA Haz Code')
export const STATE_HAZ_CODE_ERROR_MESSAGE = generateDefaultMandatoryError('State Haz Code')
export const BALE_CODE_ERROR_MESSAGE = generateDefaultMandatoryError('Bale')
export const PC_SERVICE_SITE_ERROR_MESSAGE = generateDefaultMandatoryError('Service Site')
export const STATE_PROVINCE_ERROR_MESSAGE = generateDefaultMandatoryError('State/Province')
export const COUNTRY_ERROR_MESSAGE = generateDefaultMandatoryError('Country')
export const COUNTY_ERROR_MESSAGE = generateDefaultMandatoryError('County')
export const CUSTOMER_INVOICE_ERROR_MESSAGE = generateDefaultMandatoryError('Customer invoice')
export const PURCHASE_ORDER_ERROR_MESSAGE = generateDefaultMandatoryError('Purchase Order')
export const OUTBOUND_TRAILER_ERROR_MESSAGE = generateDefaultMandatoryError('Outbound Trailer')
export const CONTRACT_DETAILS_ERROR_MESSAGE = generateDefaultMandatoryError('Contract Details')
export const PAYMENT_DETAILS_ERROR_MESSAGE = generateDefaultMandatoryError('Payment Details')
export const CUSTOMER_GENERAL_INFO_ERROR_MESSAGE =
	generateDefaultMandatoryError('Customer General Info')
export const SERVICE_REQUEST_ERROR_MESSAGE = generateDefaultMandatoryError('Service Request')
export const SUPPLIER_REQUEST_ERROR_MESSAGE = generateDefaultMandatoryError('Supplier Request')
export const UPLOAD_DOCUMENT_ERROR_MESSAGE = generateDefaultMandatoryError('Upload Document')
export const INVOICE_LOADER_ERROR_MESSAGE = generateDefaultMandatoryError('Invoice Loader')
export const SUPPLIER_LOCATION_DOCUMENT_ERROR_MESSAGE = generateDefaultMandatoryError('Document')
export const CUSTOMER_REGISTRATION_ERROR_MESSAGE = generateDefaultMandatoryError(
	'Customer Registration Request'
)
export const SAVING_ERROR_MESSAGE = generateDefaultMandatoryError('Saving')
export const ACCRUAL_ERROR_MESSAGE = generateDefaultMandatoryError('Accrual')
export const CURRENT_SUPPLIER_CONTACT_ERROR_MESSAGE = generateDefaultMandatoryError(
	'Current Supplier Contact'
)

export const INVOICE_INACTIVATION_ERROR_MESSAGE =
	'Invoice cannot be inactivated. Please fill in mandatory field:'
export const EPA_FORM_CODE_EXISTS_ERROR_MESSAGE =
	'Cannot create a new instance of EPA FORM CODE. Each instance requires a unique combination of the following fields: EPA FORM CODE ID'
export const EPA_SOURCE_CODE_EXISTS_ERROR_MESSAGE =
	'Cannot create a new instance of EPA SOURCE CODE. Each instance requires a unique combination of the following fields: EPA SOURCE CODE'
export const UPLOAD_SI_EXCEL_400_ERROR_MESSAGE =
	'The supplier invoice number for invoice loader must be unique'
export const UPLOAD_SI_EXCEL_500_ERROR_MESSAGE = 'Missing data in excel'
export const PS_RECORD_NOT_FOUND_ERROR = 'PS record is not found'
//TODO moved to Core/constants/labels
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong...'
export const COMPANY_HIERARCHY_LEVEL_ERROR_MESSAGE =
	'Company Hierarchy cannot have more than 5 levels'
export const COMPANY_HIERARCHY_SERVICE_ERROR_MESSAGE = 'Levels cannot be moved under service sites'
export const EMAIL_DUPLICATION_ERROR_MESSAGE = 'Contact with this email already exists'
export const CONTACT_PERMISSION_ERROR = `Sorry, you don't have permission to create a Contact`
export const COMPANY_ADD_REPORT_ERROR =
	'In order to assign reports please change Customer Account or Act as a Supplier attribute'
export const NO_REPORTS_MESSAGE = 'There are no reports to add'
export const CONTACT_SAVE_MESSAGE = 'Contact is saved successfully'
export const CURRENT_SUPPLIER_CONTACT_SAVE_MESSAGE =
	'Current Supplier Contact is saved successfully'
export const PROGRAM_SAVE_MESSAGE = 'Program is saved successfully'
export const CURRENT_SERVICE_PRODUCT_STATE_SAVE_MESSAGE =
	'Current Service/Product State is saved successfully'
export const CERTIFICATE_SAVE_MESSAGE = 'Certificate is saved successfully'
export const ADDRESS_SAVE_MESSAGE = 'Address is saved successfully'
export const SITE_EQUIPMENT_SAVE_MESSAGE = 'Site equipment is saved successfully'
export const BILLING_LOCATION_SAVE_MESSAGE = 'Billing Location is saved successfully'
export const PURCHASE_ORDER_APPROVE_MESSAGE = 'Purchase Order is approved successfully'
export const PURCHASE_ORDER_REJECT_MESSAGE = 'Purchase Order is rejected'
export const BILLING_LOCATION_DELETE_MESSAGE = 'Billing Location is removed successfully'
export const GUIDE_SAVE_MESSAGE = 'Guide is saved successfully'
export const LOCALE_SAVE_MESSAGE = 'Locale is saved successfully'
export const SERVICE_LOCATION_SAVE_MESSAGE = 'Service Location is saved successfully'
export const LOCATION_VISIT_SAVE_MESSAGE = 'Location Visit is saved successfully'
export const COMPANY_SAVE_MESSAGE = 'Company is saved successfully'
export const BILLING_FREQUENCY_SAVE_MESSAGE = 'Billing Frequency is saved successfully'
export const SUPPLIER_USE_SAVE_MESSAGE = 'Supplier Usage is saved successfully'
export const PROFILE_SAVE_MESSAGE = 'Contact information  is saved successfully'
export const CUSTOMER_INVOICE_SAVE_MESSAGE = 'Customer Invoice is saved successfully'
export const HISTORICAL_INVOICE_SAVE_MESSAGE = 'Historical Invoices are saved successfully'
export const CUSTOMER_CANCEL_MESSAGE =
	'Invoice was successfully Cancelled. All billing items have been moved back to Initiated'
export const CUSTOMER_INVOICE_STATUS_RESET_MESSAGE = 'Invoice status is successfully reset'
export const SITE_BUILDING_INFO_SAVE_MESSAGE = 'Site Building is saved successfully'
export const USER_SPECIFIC_REPORT_DELETED_MESSAGE = 'Report is deleted successfully'
export const CURRENT_SERVICE_PRODUCT_STATE_DELETED_MESSAGE =
	'Current Service/Product State is deleted successfully'
export const PRIVILEGE_SAVE_MESSAGE = 'Privilege is saved successfully'
export const SCALE_SAVE_MESSAGE = 'Scale is saved successfully'
export const SCALE_PRICE_SAVE_MESSAGE = 'Scale Price is saved successfully'
export const EPA_HAZAR_CODES_SAVE_MESSAGE = 'EPA Hazard Code is saved successfully'
export const EPA_HAZAR_CODES_DELETE_MESSAGE = 'EPA Hazard Code is removed successfully'
export const SERVICE_LOCATION_DELETE_MESSAGE = 'Service Location is removed successfully'
export const USER_EXPIRE_PASSWORD_MESSAGE = 'Password was successfully expired'
export const CONSTITUENT_SAVE_MESSAGE = 'Constituent is saved successfully'
export const CONSTITUENT_DELETE_MESSAGE = 'Constituent is removed successfully'
export const STATE_HAZAR_CODES_SAVE_MESSAGE = 'State Hazard Code is saved successfully'
export const STATE_HAZAR_CODES_DELETE_MESSAGE = 'State Hazard Code is removed successfully'
export const TREATMENT_METHOD_DELETE_MESSAGE = 'Treatment Method is removed successfully'
export const PHYSICAL_CHARACTERISTIC_SAVE_MESSAGE = 'Physical characteristic is saved successfully'
export const PHYSICAL_CHARACTERISTIC_DELETE_MESSAGE =
	'Physical characteristic is removed successfully'
export const DOCUMENT_APPROVED_MESSAGE = 'The document is approved successfully'
export const DOCUMENT_REJECTED_MESSAGE = 'The document is rejected'
export const OVERRIDE_NEXT_INVOICE_DATE_SAVE_MESSAGE = 'Invoice Date was saved successfully'
export const USER_SPECIFIC_REPORT_SAVE_MESSAGE = 'Report is added successfully'
export const DISPOSAL_FACILITY_SAVE_MESSAGE = 'A new disposal facility has been successfully added'
export const VARIABLE_PRICE_SAVE_MESSAGE = 'Variable price is saved successfully'
export const ITEM_SAVE_MESSAGE = 'Item is saved successfully'
export const ITEM_APPROVE_MESSAGE = 'Item is approved successfully'
export const SUPPLIER_SAVE_MESSAGE = 'Supplier is saved successfully'
export const SUPPLIER_CREATE_MESSAGE = 'Supplier is saved successfully'
export const SUPPLIER_UPDATE_MESSAGE = 'Supplier is updated successfully'
export const MANIFEST_TRANSPORTER_CREATE_MESSAGE = 'Manifest Transporter is saved successfully'
export const MANIFEST_TRANSPORTER_REMOVE_MESSAGE = 'Manifest Transporter is removed successfully'
export const MANIFEST_ITEM_CREATE_MESSAGE = 'Manifest Item is saved successfully'
export const MANIFEST_ITEM_UPDATE_MESSAGE = 'Manifest Item is updated successfully'
export const MANIFEST_ITEM_WASTE_CODE_SAVE_SUCCESS_MESSAGE =
	'Manifest Item Waste Code is saved successfully'
export const MANIFEST_ITEM_WASTE_CODE_DELETE_MESSAGE =
	'Manifest Item Waste Code is removed successfully'
export const MANIFEST_ITEM_REMOVE_MESSAGE = 'Manifest Item is removed successfully'
export const USER_SAVE_MESSAGE = 'User is saved successfully'
export const ROLE_SAVE_MESSAGE = 'Role is saved successfully'
export const SUPPLIER_LOCATION_SAVE_MESSAGE = 'Supplier location is saved successfully'
export const TRANSPORTER_SAVE_MESSAGE = 'Transporter is saved successfully'
export const WASTE_STREAM_SAVE_MESSAGE = 'Wastestream is saved successfully'
export const EMPTY_TEXT = 'There are no results to show'
export const SUPPLIER_LOCATION_ADDRESS_SUCCESS_MESSAGE =
	'Supplier location address is saved successfully'
export const DISPOSAL_FACILITY_EDIT_SUCCESS_MESSAGE = 'Disposal Facility is saved successfully'
export const DISPOSAL_FACILITY_ADDRESS_SAVE_MESSAGE =
	'Disposal facility address is saved successfully'
export const SUPPLIER_LOCATION_EDIT_SUCCESS_MESSAGE = 'Supplier location is saved successfully'
export const DISPOSAL_WASTE_STREAM_EDIT_SUCCESS_MESSAGE = 'Wastestream is saved successfully'
export const SUPPLIER_MSA_SUCCESS_MESSAGE = 'Supplier MSA is saved successfully'
export const SERVICE_AREA_SUCCESS_MESSAGE = 'Service Area is saved successfully'
export const SERVICE_AREA_DELETE_MESSAGE = 'Service Area is deleted successfully'
export const HISTORICAL_INVOICE_DELETE_MESSAGE = 'Invoice is deleted successfully'
export const REPORT_SUCCESS_MESSAGE = 'Report is saved successfully'
export const TAX_CATEGORY_SUCCESS_MESSAGE = 'Tax Category is saved successfully'
export const TAX_EXEMPTION_SUCCESS_MESSAGE = 'Tax Exemption is saved successfully'
export const WHERE_PARAMETER_SUCCESS_MESSAGE = 'Where Parameter is saved successfully'
export const WHERE_PARAMETER_DELETE_MESSAGE = 'Where Parameter is deleted successfully'
export const SQL_PARAMETER_SUCCESS_MESSAGE = 'SQL Parameter is saved successfully'
export const SQL_PARAMETER_DELETE_MESSAGE = 'SQL Parameter is deleted successfully'
export const CURRENT_SUPPLIER_CONTACT_DELETE_MESSAGE =
	'Current Supplier Contact is deleted successfully'
export const CURRENT_CUSTOMER_CONTACT_DELETE_MESSAGE =
	'Current Customer Contact is deleted successfully'
export const SERVICE_AREAS_SUCCESS_MESSAGE = 'Service Areas are saved successfully'
export const ITEM_TEMPLATE_SAVE_MESSAGE = 'Template is saved successfully'
export const SUPPLIER_ITEM_SAVE_MESSAGE = 'Supplier Item is saved successfully'
export const ITEM_PRICE_SAVE_MESSAGE = 'Item Price is saved successfully'
export const ITEM_PRICE_DELETE_MESSAGE = 'Item Price is deleted successfully'
export const CONTRACT_SUCCESS_MESSAGE = 'Contract is saved successfully'
export const HES_SUPPLIER_SAVE_MESSAGE = 'HES Supplier is saved successfully'
export const DOCUMENT_SUCCESS_MESSAGE = 'Document is saved successfully'
export const BILLING_ITEM_SUCCESS_MESSAGE = 'Billing Item is saved successfully'
export const INVOICE_LOADER_SUCCESS_MESSAGE = 'Invoice Loader is saved successfully'
export const BILLING_ITEM_DUPLICATE_SUCCESS_MESSAGE = 'Billing Item is created successfully'
export const BILLING_ITEM_CHANGE_CUSTOMER_SUCCESS_MESSAGE = 'Customer is successfully changed'
export const PREBILL_SUCCESS_MESSAGE = 'Prebill is saved successfully'
export const PRODUCER_SUCCESS_MESSAGE = 'Producer is saved successfully'
export const TREATMENT_METHOD_SUCCESS_MESSAGE = 'Treatment Method is saved successfully'
export const GENERAL_LIABILITY_SUCCESS_MESSAGE = 'General Liability is saved successfully'
export const SUPPLIER_INVOICE_SAVE_MESSAGE = 'Invoice is saved successfully'
export const AUTO_LIABILITY_SUCCESS_MESSAGE = 'Auto Liability is saved successfully'
export const EXCESS_UMBRELLA_LIABILITY_SUCCESS_MESSAGE =
	'Excess / Umbrella Liability is saved successfully'
export const DEPENDENT_ITEM_SUCCESS_MESSAGE = 'Dependent Item is saved successfully'
export const SERVICE_SCHEDULE_SUCCESS_MESSAGE = 'Service Schedule is saved successfully'
export const WORKERS_LIABILITY_SUCCESS_MESSAGE =
	"Worker's Comp / EL Liability is saved successfully"
export const KPI_TRACKING_SAVE_MESSAGE = 'KPI Tracking is saved successfully'
export const OTHER_LIABILITY_SUCCESS_MESSAGE = 'Other Liability is saved successfully'
export const PRICE_SAVE_MESSAGE = 'Price is saved successfully'
export const RELATED_ITEM_WARNING_MESSAGE =
	'Related active item’s status will be set to INACTIVE upon save'
export const SUPPLIER_INVOICE_CANCEL_MESSAGE = 'Invoice was successfully cancelled'
export const PARAMETERS_SUCCESS_MESSAGE = 'Parameter is saved successfully'
export const SUPPLIER_INVOICE_REASSIGN_SUCCESS_MESSAGE = 'Invoice was successfully reassigned'
export const SUPPLIER_INVOICE_INACTIVATION_SUCCESS_MESSAGE = 'Invoice was successfully inactivated'
export const SUPPLIER_INVOICE_REACTIVATION_SUCCESS_MESSAGE = 'Invoice was successfully reactivated'
export const NOTE_SAVE_MESSAGE = 'Note is saved successfully'
export const MANIFEST_SUCCESS_MESSAGE = 'Manifest is saved successfully'
export const EXCEPTION_SUCCESS_MESSAGE = 'Exception is saved successfully'
export const COMMENT_SUCCESS_MESSAGE = 'Comment is saved successfully'
export const ACCOUNT_CATEGORY_SUCCESS_MESSAGE = 'Account Category is saved successfully'
export const TREATMENT_CATEGORY_SUCCESS_MESSAGE = 'Treatment Category is saved successfully'
export const CATEGORY_SUCCESS_MESSAGE = 'Category is saved successfully'
export const COMPANY_HIERARCHY_SUCCESS_MESSAGE = 'Company Hierarchy is saved successfully'
export const UPLOAD_SI_EXCEL_SUCCESS_MESSAGE =
	'Invoice was successfully loaded. Please wait until it’s processed'
export const SERVICE_SUCCESS_MESSAGE = 'Service is saved successfully'
export const SERVICE_DELETE_SUCCESS_MESSAGE = 'Service is removed successfully'
export const EXTRA_CHARGE_DELETE_SUCCESS_MESSAGE = 'Extra charge is removed successfully'
export const SERVICE_TEAM_SAVE_SUCCESS_MESSAGE = 'Service Team is saved successfully'
export const MOU_SUCCESS_MESSAGE = 'MOU is saved successfully'
export const EXTRA_CHARGE_SUCCESS_MESSAGE = 'Extra Charge is saved successfully'
export const INVOICE_LOAD_CANCEL_SUCCESS_MESSAGE = 'Invoice was cancelled successfully'
export const SERVICE_OCCURRENCE_SUCCESS_MESSAGE = 'Service Occurrence is saved successfully'
export const TRANSACTION_DOCUMENT_SUCCESS_MESSAGE = 'Transaction Document is saved successfully'
export const PRODUCT_CATEGORY_SUCCESS_MESSAGE = 'Product Category is saved successfully'
export const PRODUCT_TYPE_SUCCESS_MESSAGE = 'Product Type is saved successfully'
export const SUPPLIER_INVOICE_SUCCESS_MESSAGE = 'Supplier Invoice is saved successfully'
export const PRODUCTS__SUCCESS_MESSAGE = 'Product is saved successfully'
export const PRODUCT_STATE_SAVE_SUCCESS_MESSAGE = 'Product State is saved successfully'
export const TREATMENT_SAVE_SUCCESS_MESSAGE = 'Treatment Method is saved successfully'
export const INVENTORY_LOCATION_SAVE_SUCCESS_MESSAGE = 'Inventory Location is saved successfully'
export const CONTAINER_TYPE_SAVE_SUCCESS_MESSAGE = 'Container Type is saved successfully'
export const CONTAINER_SAVE_SUCCESS_MESSAGE = 'Container was successfully saved'
export const INVOICE_ADJUSTMENT_SUCCESS_MESSAGE =
	'Adjustments were created for this invoice. Please check the section Invoice Adjustments'
export const INVOICE_ADJUSTMENT_FINISH_SUCCESS_MESSAGE =
	'Adjustments were successfully created for this invoice. Please check the section Invoice Adjustments'
export const PC_SUPPLIER_LOCATION_SUCCESS_MESSAGE = 'Supplier Location is saved successfully'
export const PC_PRODUCT_WEIGHT_SAVE_SUCCESS_MESSAGE = 'Product Weight is saved successfully'
export const PC_INVENTORY_LOCATION_SAVE_SUCCESS_MESSAGE = 'Inventory Location is saved successfully'
export const PC_SL_SINGLE_DELETE_SUCCESS_MESSAGE = 'Supplier Location is deleted successfully'
export const PC_SL_MULTIPLE_DELETE_SUCCESS_MESSAGE = 'Supplier Locations are deleted successfully'
export const EPA_SOURCE_CODE_SUCCESS_MESSAGE = 'EPA Source Code is saved successfully'
export const EPA_FORM_CODE_SUCCESS_MESSAGE = 'EPA Form Code is saved successfully'
export const EPA_HAZ_CODE_SUCCESS_MESSAGE = 'EPA Haz Code is saved successfully'
export const PROCESSING_CENTER_CONTACT_SAVE_SUCCESS_MESSAGE = 'Contact is saved successfully'
export const PC_SERVICE_SITE_SINGLE_DELETE_MESSAGE = 'Service Site is deleted successfully'
export const PC_SERVICE_SITE_MULTIPLE_DELETE_MESSAGE = 'Service Sites are deleted successfully'
export const STATE_HAZ_CODE_SUCCESS_MESSAGE = 'State Haz Code is saved successfully'
export const PC_SERVICE_SITE_SUCCESS_MESSAGE = 'Service Site is saved successfully'
export const STATE_PROVINCE_SUCCESS_MESSAGE = 'State/Province is saved successfully'
export const COUNTRY_SUCCESS_MESSAGE = 'Country is saved successfully'
export const LOCALITY_SAVE_SUCCESS_MESSAGE = 'Locality is saved successfully'
export const COUNTY_SUCCESS_MESSAGE = 'County is saved successfully'
export const DEPENDENT_ITEM_DELETE_SUCCESS_MESSAGE = 'Dependent Item is deleted successfully'
export const BILLING_ITEMS_SUCCESS_MESSAGE = 'Billing Items are added successfully'
export const BILLING_ITEMS_REMOVED_SUCCESS_MESSAGE = 'Billing item/s were removed successfully'
export const BALE_SUCCESS_MESSAGE = 'Bale is saved successfully'
export const CHARGES_SUCCESS_MESSAGE = 'Charges were successfully moved'
export const PUCHASE_ORDER_SUCCESS_MESSAGE = 'Purchase Order is saved successfully'
export const INBOUND_TRAILER_SUCCESS_MESSAGE = 'Inbound Trailer is saved successfully'
export const INSERT_LATE_FEES_SUCCESS_MESSAGE = 'Late fees are calculated'
export const ORDERS_SUCCESS_MESSAGE = 'Order/s are saved successfully'
export const OUTBOUND_TRAILER_SUCCESS_MESSAGE = 'Outbound Trailer is saved successfully'
export const BALE_DELETE_SUCCESS_MESSAGE = 'Bale is deleted successfully'
export const BALES_ADD_SUCCESS_MESSAGE = 'Bales are added successfully'
export const BALE_ADD_SUCCESS_MESSAGE = 'Bale is added successfully'
export const BALE_MATERIAL_SUCCESS_MESSAGE = 'Bales are saved successfully'
export const CUSTOMER_INVOICE_CANCEL_EMAIL_SUCCESS = 'Email was removed from queue'
export const LOCALE_SUCCESS_MESSAGE = 'Locale is saved successfully'
export const CONTRACT_DETAILS_SUCCESS_MESSAGE = 'Contract Details is saved successfully'
export const PAYMENT_DETAILS_SUCCESS_MESSAGE = 'Payment Details is saved successfully'
export const AGING_REASON_SUCCESS_MESSAGE = 'Reason of Aging is saved successfully'
export const MOVE_EXPENSE_SUCCESS_MESSAGE = 'Expense is successfully moved'
export const CUSTOMER_GENERAL_INFO_SUCCESS_MESSAGE = 'Customer General Info is saved successfully'
export const REASSIGN_SUCCESS_MESSAGE = 'Reassign is saved successfully'
export const RESOLVE_SUCCESS_MESSAGE = 'Resolve is saved successfully'
export const NOTE_SUCCESS_MESSAGE = 'Note is saved successfully'
export const CONVENTION_SUCCESS_MESSAGE = 'Convention is saved successfully'
export const SERVICE_REQUEST_SUCCESS_MESSAGE = 'Service Request is saved successfully'
export const SERVICE_REQUEST_ITEM_CANCELED_MESSAGE = 'Service is canceled successfully'
export const CONVENTION_SAVE_SUCCESS_MESSAGE = 'Convention is saved successfully'
export const CONVENTION_DELETE_SUCCESS_MESSAGE = 'Convention is removed successfully'
export const SUPPLIER_REQUEST_ADD_SUCCESS_MESSAGE = 'You have successfully added Supplier Request'
export const SUPPLIER_REQUEST_EDIT_SUCCESS_MESSAGE = 'You have successfully saved Supplier Request'
export const SUPPLIER_REQUEST_ADD_ADDRESS_ERROR_MESSAGE = 'Following Address exists in the system'
export const CONFIRMATION_EMAIL_SUCCESS_MESSAGE = 'Confirmation Email is sent successfully'
export const DOCUMENT_DELETE_SUCCESS_MESSAGE = 'Document is removed successfully'
export const COMPLETE_SUPPLIER_REQUEST_SUCCESS_MESSAGE =
	'You have successfully completed the Supplier Request'
export const REJECT_SUPPLIER_REQUEST_SUCCESS_MESSAGE = 'You have rejected the Supplier Request'
export const REOPEN_SUPPLIER_REQUEST_SUCCESS_MESSAGE =
	'You have successfully reopened the Supplier Request'
export const CONFIRM_SUPPLIER_REQUEST_SUCCESS_MESSAGE =
	'You have successfully confirmed the Supplier Request'
export const CUSTOMER_REGISTRATION_REQUEST_SUCCESS_MESSAGE =
	'Customer Registration Request is saved successfully. The Customer Contact will receive a registration link'
export const MANUAL_ADJUSTMENT_REQUEST_SUCCESS_MESSAGE =
	'Manual Accrual Adjustment is saved successfully'
export const FINISH_JOURNAL_DATE_SUCCESS_MESSAGE =
	'Journal Date is successfully closed and Revised Accruals reports will be generated.'
export const MOVE_TO_QUEUE_SUCCESS_MESSAGE = 'Successfully Moved to Queue'
export const SEND_TO_RAPID_CANVAS_SUCCESS_MESSAGE = 'Successfully Sent to RapidCanvas'
export const BANNER_SUCCESS_MESSAGE = 'Banner is saved successfully'
export const ADD_BANNER_ERROR = generateDefaultMandatoryError('Banner')

export const REASSIGN_SERVICE_REQUEST_SUCCESS_MESSAGE = 'Service Request is reassigned successfully'
export const REASSIGN_SERVICE_REQUEST_ERROR_MESSAGE =
	'Service Request cannot be reassigned. Please fill in mandatory fields:'
export const CUSTOMER_REGISTRATION_REQUEST_SAVE_SUCCESS_MESSAGE =
	'Customer Registration Request is saved successfully.'
export const CUSTOMER_REGISTRATION_REQUEST_COMPLETE_SUCCESS_MESSAGE =
	'Customer Registration Request is completed successfully.'
export const CUSTOMER_REGISTRATION_REQUEST_RESEND_LINK_SUCCESS_MESSAGE =
	'Invitation link has been resent successfully.'
export const ACCRUAL_SUCCESS_MESSAGE = 'Accrual is saved successfully'
export const ACCRUAL_DECLINE_MESSAGE = 'Linked Accrual Adjustment is declined successfully'

export const getExceptionUnreadNotification = (entityType: BasicString) =>
	`This ${entityType || 'entity'} has Issues. Please check the Activity sidebar`

export const getItemValidationErrorMessageById = (itemId: Key): string =>
	`Item ${itemId} has errors and cannot be activated, please open the item and use “Approve” button to see details`

export const generateCustomerInvoiceSuccessMessage = (id: Key) =>
	`Customer Invoice ${id} is successfully generated`

export const getUomMismatchMessage = (metadataUomName: BasicString, itemUomName: BasicString) =>
	`The unit of measure provided by Rapid Canvas of ${metadataUomName} does not match the selected item's unit of measure of ${itemUomName}`

export const generateFinishInvoiceSuccessMessage = (
	isRequestReview: boolean,
	invoiceNumber: Key,
	invoiceBarcodeNumber: Key
) =>
	isRequestReview
		? `Manual Review for the Invoice ${invoiceBarcodeNumber} [${invoiceNumber}] was requested successfully`
		: `The Invoice ${invoiceBarcodeNumber} [${invoiceNumber}] has been successfully approved.`

export const SCALE_PRICE_OVERLAP_MESSAGE =
	'Ordering value range (Low Value - High Value) can not overlap with existing ordering value ranges of other Scale Prices'

export const UNIT_PRICE_RANGE_ERROR_MESSAGE = 'Unit Price is not within price range'

export const VARIABLE_PRICE_OVERLAP_MESSAGE =
	'Effective date range (Effective Start Date - Effective End Date) can not overlap with existing effective date ranges of other Prices'

export const EXCEPTION_WARNING =
	'Before sending the exception, please check inactive Items in the Service List.'

export const SOC_GENERATION_STARTED_MESSAGE =
	'Service Occurrence generation has started. It may take several minutes for it to complete. You can view the progress on the Supplier Invoice page.'

export const SOC_GENERATION_COMPLETED_MESSAGE = 'Service Occurrence generation completed.'

export const SOC_GENERATION_COMPLETED_WITH_ERRORS_MESSAGE =
	'Service Occurrence generation completed with errors. Please see the exception for details'

export const SOC_GENERATION_FAILED_MESSAGE =
	'Service Occurrence generation failed. Please see the exception for details.'

export const SOC_GENERATION_NO_MAPPED_ITEMS_ERROR =
	'Cannot create SOCs — at least one item needs to be mapped. Please map at least one item and try again.'

export const getSocGenerationProgressMessage = (createdCount: number, totalSocNum: number) =>
	`Service Occurrence generation is in progress: ${createdCount} of ${totalSocNum} created.`

export const REF_CODE_IS_INCORRECT_ERROR =
	'The following Wastestream can`t be added,  please double check the Wastestream Reference Code'

export const REF_CODE_IS_EXIST_WARNING =
	'Following Wastestream already exists. Would you like to update the Wastestream data from HES?'

export const WASTESTREAM_FROM_HES_PULLED_SUCCESS_MESSAGE =
	'The Information has been successfully pulled from HES. Click Save to keep the fields information'

export const INVOICE_LOADER_READY_ERROR_MESSAGE =
	'Invoice cannot be Loader Ready. Please fill in mandatory fields: '

export const INVALID_EMAIL_MESSAGE = 'Invalid Email'

export const INVALID_WEBSITE_MESSAGE = 'Invalid Website Address'

export const NO_FILTERS_ERROR_MESSAGE =
	'Please choose at least one filter criteria to start the search'
